export default __webpack_public_path__ + "static/waskita-216c3bfac578c1714b9b82c322db0439.webp";